import { Pagination } from "@mui/material";
import { MoreHorizontal } from "lucide-react";
import { useEffect, useState } from "react";
import { useForm } from "react-hook-form";
import toast from "react-hot-toast";
import { checkTagValidity } from "../../Utils/Utils";
import { ADD_EQUIP, DELETE_EQUIP, UPDATE_EQUIP } from "../../Utils/constant";
import { Loader } from "../../components/Widget/Loader";
import { deleteOne, store, updateOne } from "../../services/service";
import { useStoreEquipement } from "../../store/Paramettre/equipementStore";

export const TypeEquipement = () => {
  const {
    register,
    handleSubmit,
    reset,
    formState: { errors },
  } = useForm();
  const [isSubmit, setIsSubmit] = useState(false);
  const [editItem, setEditItem] = useState(null);
  const [deleteItem, setDeleteItem] = useState(null);
  const typeEquipements = useStoreEquipement();

  const openAdd = () => {
    setEditItem(null);
    reset({ designation: "", cout: "" });
    document.getElementById("modal_add").showModal();
  };

  const openEdit = (item) => {
    setEditItem(item);
    reset({ designation: item.designation, cout: item.cout });
    document.getElementById("modal_add").showModal();
  };

  const submit = (data) => {
    setIsSubmit(true);
    const req = editItem
      ? updateOne(UPDATE_EQUIP, editItem.id, data)
      : store(ADD_EQUIP, "application/json", data);

    req
      .then((res) => {
        setIsSubmit(false);
        if (res.status === 200) {
          reset();
          setEditItem(null);
          document.getElementById("modal_add").close();
          toast.success(
            editItem ? "Équipement mis à jour" : "Équipement ajouté",
          );
          typeEquipements.equipement({ page: 0, param: "", size: 10 });
        }
      })
      .catch((err) => {
        setIsSubmit(false);
        toast.error(err.response.data.donnee);
      });
  };

  useEffect(() => {
    typeEquipements.equipement({ page: 0, param: "", size: 10 });
  }, []);

  const more = (page) =>
    typeEquipements.equipement({ page: page - 1, param: "", size: 10 });

  const inputCls =
    "w-full h-10 px-3 border border-gray-200 rounded-lg text-sm text-gray-900 bg-gray-50 outline-none focus:border-yellow-400 focus:ring-2 focus:ring-yellow-100 transition";
  const closeBtnCls =
    "w-8 h-8 flex items-center justify-center rounded-lg bg-gray-100 hover:bg-gray-200 text-gray-500 text-sm font-semibold transition";

  return (
    <>
      {/* Header */}
      <div className="mt-4 mb-1">
        <p className="text-2xl font-bold text-gray-900 tracking-tight">
          Types d'équipement
        </p>
        <p className="text-sm text-gray-400 mt-1">
          Gestion des types d'équipements et leurs coûts
        </p>
      </div>

      {/* Toolbar */}
      <div className="flex flex-wrap items-center gap-3 py-4 border-b border-gray-100 mb-6">
        <div className="flex items-center gap-2 bg-gray-50 border border-gray-200 rounded-xl px-3 h-10">
          <svg
            width="15"
            height="15"
            viewBox="0 0 24 24"
            fill="none"
            stroke="#9ca3af"
            strokeWidth="2"
          >
            <circle cx="11" cy="11" r="8" />
            <path d="m21 21-4.35-4.35" />
          </svg>
          <input
            type="text"
            placeholder="Rechercher un équipement…"
            className="bg-transparent border-none outline-none text-sm text-gray-900 placeholder-gray-400 w-52"
          />
        </div>

        {checkTagValidity("AJOUTER _TYPE_EQUIPEMENT") && (
          <button
            onClick={openAdd}
            className="ml-auto h-10 px-4 bg-yellow-400 hover:bg-yellow-300 text-gray-900 text-sm font-semibold rounded-xl transition"
          >
            Ajouter
          </button>
        )}
      </div>

      {/* Add / Edit Modal */}
      <dialog id="modal_add" className="modal">
        <div className="modal-box rounded-2xl p-6 max-w-md">
          <div className="flex items-center justify-between mb-5">
            <h2 className="text-lg font-bold text-gray-900">
              {editItem ? "Modifier l'équipement" : "Nouvel équipement"}
            </h2>
            <form method="dialog">
              <button onClick={() => setEditItem(null)} className={closeBtnCls}>
                ✕
              </button>
            </form>
          </div>

          {editItem && (
            <div className="bg-gray-50 border border-gray-200 rounded-lg px-4 py-3 mb-4">
              <p className="text-xs text-gray-500">Équipement actuel</p>
              <p className="text-sm font-semibold text-gray-900 mt-0.5">
                {editItem.designation}
              </p>
              <p className="text-xs text-gray-400 mt-0.5">
                Coût : {editItem.cout}
              </p>
            </div>
          )}

          <form onSubmit={handleSubmit(submit)} className="space-y-4">
            <div>
              <label className="block text-xs font-medium text-gray-700 mb-1.5">
                Désignation <span className="text-red-500">*</span>
              </label>
              <input
                type="text"
                className={inputCls}
                {...register("designation", { required: true })}
              />
              {errors.designation && (
                <p className="text-xs text-red-500 mt-1">
                  Ce champ est obligatoire
                </p>
              )}
            </div>

            <select
              {...register("typeClient", { required: true })}
              className="select select-bordered w-full h-10"
            >
              <option value="">type de client</option>
              <option value="PARTICULIER">Particulier</option>
              <option value="ENTREPRISE">Entreprise</option>
            </select>

            <div>
              <label className="block text-xs font-medium text-gray-700 mb-1.5">
                Coût de l'équipement <span className="text-red-500">*</span>
              </label>
              <input
                type="number"
                className={`${inputCls} [appearance:textfield] [&::-webkit-outer-spin-button]:appearance-none [&::-webkit-inner-spin-button]:appearance-none`}
                {...register("cout", { required: true })}
              />
              {errors.cout && (
                <p className="text-xs text-red-500 mt-1">
                  Ce champ est obligatoire
                </p>
              )}
            </div>

            <button
              type="submit"
              disabled={isSubmit}
              className={`w-full h-10 rounded-xl text-sm font-semibold flex items-center justify-center gap-2 transition ${
                isSubmit
                  ? "bg-gray-100 text-gray-400 cursor-not-allowed"
                  : "bg-yellow-400 hover:bg-yellow-300 text-gray-900"
              }`}
            >
              {isSubmit ? (
                <>
                  <span className="loading loading-spinner loading-xs" />{" "}
                  Enregistrement…
                </>
              ) : editItem ? (
                "Enregistrer les modifications"
              ) : (
                "Enregistrer"
              )}
            </button>
          </form>
        </div>
      </dialog>

      {/* Delete Modal */}
      <dialog id="delete_equipement" className="modal">
        <div className="modal-box rounded-2xl p-6 max-w-md">
          <p className="text-base font-bold text-gray-900 mb-1">
            Confirmer la suppression
          </p>
          <p className="text-sm text-gray-500 mb-6">
            L'équipement{" "}
            <span className="font-semibold text-gray-800">
              {deleteItem?.designation}
            </span>{" "}
            sera définitivement supprimé.
          </p>
          <div className="flex justify-end gap-2">
            <form method="dialog">
              <button className="h-9 px-4 rounded-lg text-sm font-medium bg-gray-100 hover:bg-gray-200 text-gray-700 transition">
                Annuler
              </button>
            </form>
            <form method="dialog">
              <button
                onClick={() => {
                  deleteOne(DELETE_EQUIP, deleteItem.id)
                    .then(() => {
                      typeEquipements.equipement({
                        page: 0,
                        param: "",
                        size: 10,
                      });
                      toast.success(`${deleteItem.designation} supprimé`);
                    })
                    .catch(() => {});
                }}
                className="h-9 px-4 rounded-lg text-sm font-medium bg-red-500 hover:bg-red-600 text-white transition"
              >
                Supprimer
              </button>
            </form>
          </div>
        </div>
      </dialog>

      {/* Grid */}
      {typeEquipements?.loading ? (
        <Loader />
      ) : typeEquipements?.data?.equipements?.length === 0 ? (
        <div className="flex items-center justify-center h-48">
          <p className="text-sm text-gray-400">Aucun équipement trouvé</p>
        </div>
      ) : (
        <div className="grid grid-cols-2 md:grid-cols-3 lg:grid-cols-4 xl:grid-cols-5 2xl:grid-cols-6 gap-3">
          {typeEquipements?.data?.equipements?.map((item) => (
            <div
              key={item.id}
              className="relative bg-white border border-gray-200 rounded-xl p-3 flex items-center gap-3 hover:shadow-md hover:border-yellow-300 transition-all duration-200"
            >
              {/* Menu */}
              <div className="dropdown dropdown-end absolute top-2 right-2">
                <div
                  tabIndex={0}
                  role="button"
                  className="w-7 h-7 flex items-center justify-center rounded-lg border border-gray-200 bg-white hover:bg-gray-50 text-gray-500 transition cursor-pointer"
                >
                  <MoreHorizontal size={15} />
                </div>
                <ul
                  tabIndex={0}
                  className="dropdown-content z-10 mt-1 bg-white border border-gray-200 rounded-xl shadow-lg w-40 p-1.5"
                >
                  <li>
                    <button
                      className="w-full h-8 px-3 text-left text-xs font-medium text-gray-700 rounded-lg hover:bg-gray-50 transition"
                      onClick={() => openEdit(item)}
                    >
                      Modifier
                    </button>
                  </li>
                  <li>
                    <button
                      className="w-full h-8 px-3 text-left text-xs font-medium text-red-600 rounded-lg hover:bg-red-50 transition"
                      onClick={() => {
                        setDeleteItem(item);
                        document
                          .getElementById("delete_equipement")
                          .showModal();
                      }}
                    >
                      Supprimer
                    </button>
                  </li>
                </ul>
              </div>

              {/* Icon */}
              <div className="w-10 h-10 rounded-xl bg-amber-50 border border-amber-100 flex items-center justify-center shrink-0 text-amber-500 font-bold text-sm">
                {item.designation?.[0]?.toUpperCase()}
              </div>

              {/* Info */}
              <div className="flex-1 min-w-0 pr-6">
                <p className="text-xs font-semibold text-gray-900 truncate">
                  {item.designation}
                </p>
                <p className="text-xs text-gray-400 mt-0.5 font-medium">
                  {item.cout} FCFA
                </p>
              </div>
            </div>
          ))}
        </div>
      )}

      {/* Pagination */}
      <div className="flex justify-end mt-6">
        <Pagination
          onChange={(_, v) => more(v)}
          count={typeEquipements.count}
          variant="outlined"
          color="primary"
          shape="rounded"
          size="small"
        />
      </div>
    </>
  );
};
